import { type ComponentPropsWithoutRef } from 'react';
import Modal from '@/components/Modal';
import { BlockButton } from '@/components/BlockButton';
import { showErrorToast, showSuccessToast } from '../../job_change_processes/lib/toast';

type Props = {
  modal: Omit<ComponentPropsWithoutRef<typeof Modal>, 'children'>;
  close: () => void;
  providedJobPostId: number;
  jobPostTitle: string;
  onSuccess?: () => void;
};

export default function ProvidedJobPostDeleteConfirmModal({
  modal,
  close,
  providedJobPostId,
  jobPostTitle,
  onSuccess,
}: Props) {
  const handleDelete = async () => {
    try {
      const response = await fetch(`/agent/api/provided_job_posts/${providedJobPostId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        showErrorToast('この求人は削除できません');
        return;
      }

      showSuccessToast('求人を削除しました');
      close();

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      showErrorToast('求人の削除に失敗しました');
    }
  };

  return (
    <Modal {...modal}>
      <div className="w-[640px] rounded bg-white">
        <div className="flex h-[56px] items-center border-b border-solid border-border px-6">
          <p className="text-base font-bold">削除の確認</p>
        </div>
        <div className="p-6">
          <p className="mb-4 text-base">以下の求人を削除しますか？</p>
          <div className="rounded-lg bg-gray-50 p-4">
            <p className="font-medium">{jobPostTitle}</p>
          </div>
          <p className="mt-4 text-sm text-red-600">
            この操作は取り消せません。関連する提案情報や選考情報も含めて完全に削除されます。
          </p>
        </div>
        <div className="flex h-[74px] items-center justify-end gap-4 border-t border-solid border-border px-6">
          <div className="w-[94px]">
            <BlockButton type="button" text="キャンセル" colorType="white" onClick={close} />
          </div>
          <div className="w-[80px]">
            <BlockButton type="button" text="削除" colorType="red" onClick={handleDelete} />
          </div>
        </div>
      </div>
    </Modal>
  );
}
